import { RefObject, useEffect } from 'react'

const useClickOutside = (
  ref: RefObject<HTMLElement>,
  inputName: string,
  popName: string,
  fisrtCallBack: () => void,
  secondCallback: () => void,
) => {
  const handleClick = (event: MouseEvent) => {
    const container = ref.current
    const target = event.target as HTMLElement

    if (
      target.classList.contains(`
          ${popName}-popup`)
      || target.closest(`
          .${popName}-popup`)
    ) {
      return
    }

    if (
      target.classList.contains(`${inputName}-input-container`)
      || target.closest(`.${inputName}-input-container`)
    ) {
      fisrtCallBack()
      return
    }

    if (!container?.contains(target)) {
      secondCallback()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)

    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [handleClick])
}

export default useClickOutside
